// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__hOLTk","label":"Radio_label__2pu9d","checkMark":"Radio_checkMark__tDt6N","disabled":"Radio_disabled__3pcwT"};